// Copyright (c) StrangeBee 2023

import React, { useContext, useState, useEffect, ReactElement } from 'react';
import { TabContext } from '@Context/TabProvider';
import { useLocalMessage } from '@Helpers/locale';
import { buildPath } from '@Helpers/string';
import { RouteType } from '@Types';
import { useHistory } from 'react-router';
import { THTooltip } from '@Molecules/THTooltip/THTooltip';
import { THButton } from '@Molecules/Inputs/THButton/THButton';

import './Shortcut.scss';

interface ShortcutProps {
    routes: RouteType[];
    paramName: string;
    entityId: string;
}

export const Shortcut = ({ routes, paramName, entityId }: ShortcutProps): ReactElement => {
    const i = useLocalMessage();
    const history = useHistory();
    const { add } = useContext(TabContext);
    const [routesDisplay, setRoutesDisplay] = useState<RouteType[]>(routes);

    const onAdd = (e: RouteType) => () => {
        add(e.path);
        history.push(buildPath(e.path, paramName, entityId));
    };

    useEffect(() => {
        const closable = routes.filter(({ menu }) => menu?.shortcut);
        setRoutesDisplay(closable);
    }, [routes]);

    return (
        <nav className="shortcut-list">
            {routesDisplay.map((e) => {
                const label = e.menu?.render || (e.menu?.label && i(e.menu?.label));
                return (
                    <THTooltip title={label} key={e.path}>
                        <THButton
                            className="shortcut-list__item"
                            key={e.path}
                            onClick={onAdd(e)}
                            icon={e?.menu?.shortcut?.render || e.menu?.icon}
                            shape="circle"
                        />
                    </THTooltip>
                );
            })}
        </nav>
    );
};
